// src/auth/PrivateRoute.js
import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const PrivateRoute = ({ children }) => {
  const { token, authReady, user, logout } = useAuth();
  const lsToken = localStorage.getItem('access_token');
  const navigate = useNavigate();

  // Avoid redirect loops in slower deployed environments while auth session is hydrating.
  if (!authReady) return null;

  // Not authenticated -> redirect to public landing/login
  if (!(token || lsToken)) return <Navigate to="/" replace />;

  // If user exists but was NOT provisioned by an admin, block access and show message
  if (user && user.provisioned_by_admin === false) {
    return (
      <div style={{height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <div style={{maxWidth: 720, padding: 24, textAlign: 'center'}}>
          <h1 style={{fontSize: 20, marginBottom: 12}}>Access Pending</h1>
          <p style={{color: '#666'}}>Contact Administrator for access to the Application. You do not have the required access.</p>
          <div style={{marginTop: 16}}>
            <button
              onClick={() => { logout(); navigate('/'); }}
              style={{padding: '8px 12px', background: '#e53e3e', color: '#fff', border: 'none', borderRadius: 4, cursor: 'pointer'}}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default PrivateRoute;
